// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3qAcU","label":"styles__label___324HP"};